var App = App || {};

App.TestimonialsBand = (function ($) {
    "use strict";

    function init() {
        const TestimonialsBand = $(".component.component-testimonialsband.hasCarousel");
        if (TestimonialsBand.length) {
            TestimonialsBand.each(function () {
                TestimonialsCarousels(TestimonialsBand);
            });
        }

        $(".component.component-testimonialsband").ZagScrollAnimate({
            offset: 75,
            targets: [
                { selector: ".testimonialsband-card-text", type: "animate__fadeInLeft", stagger: 0 }
            ]
        });


        $(".component.component-testimonialsband .testimonialsband-card-image-wrapper").ZagParallax({ divisor: 15 });
    }

    function TestimonialsCarousels(TestimonialsBand) {

        const carousel = TestimonialsBand.find(".cardrow.carousel-True");
        const prevBtn = TestimonialsBand.find(".visual-splide__arrow.previous");
        const nextBtn = TestimonialsBand.find(".visual-splide__arrow.next");

        const splide = new Splide(carousel[0], {
            pagination: false,
            type: 'fade',
            rewind: true,
            fixedWidth: "100vw",
            drag: false,
        });

        prevBtn.on("click", function () {
            TestimonialsBand.find(".splide__arrow--prev").click();
        });

        nextBtn.on("click", function () {
            TestimonialsBand.find(".splide__arrow--next").click();
        });

        // Updates the status:
        splide.on('ready active resized', function () {
            TestimonialsBand.css("max-height", TestimonialsBand.find(".splide__slide.is-active").height());
        });

        splide.mount();
    }
    return {
        init: init
    };

})(jQuery);

$(function () {
    App.TestimonialsBand.init();
});